import Page from "webPage/Page";
import ProfileModal from "modal/ProfileModal";
import {RegionalProfileModal} from "modal/RegionalProfileModal";

Page.register("page-template-quienes-somos", () => {

    $('body').on('click', '.js-profile', function () {
        (new ProfileModal($(this))).show();
        return false;
    }).on('click', '.js-regional-profile', function () {
        (new RegionalProfileModal($(this))).show();
        return false;
    });
});